import styled from "styled-components";
import {
  GoldContainer,
  MainContainer,
  FlexContainer,
  TextContainer,
} from "./containers";
import { GoldButton } from "../../components/GoldButton";
import { GoldTitle } from "../../components/GoldTitle";
import { useMainDescriptionsQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
const Title = styled(TextContainer)`
  align-self: flex-start;
  padding-bottom: 60px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  p {
    max-width: 500px;

    text-align: justify;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    p {
      padding: 20px 0;
    }
  }
  ${GoldTitle} {
    text-align: left;
    text-transform: uppercase;
  }
`;

const ImgContainer = styled.div<{ right?: boolean }>`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: ${({ right }) => (right ? "flex-start" : "flex-end")};

  gap: 20px;
  flex: 1;
  img {
    max-width: 350px;
    height: auto;
    z-index: 1;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
`;

export function EventiSport() {
  const { data: dataIntro } = useMainDescriptionsQuery({
    variables: { id: "17CklKyc5whFAmFJKUFRSm" },
  });
  const { data: dataClinic } = useMainDescriptionsQuery({
    variables: { id: "4jvmQQyBTbNNY34agn7QO" },
  });
  const { data: dataExpirience } = useMainDescriptionsQuery({
    variables: { id: "61fSikdGXZqMIi3kbjQaqN" },
  });
  return (
    <FlexContainer $bgColor='#ABA9A938' $color='black'>
      <MainContainer>
        <Title>
          <h1>{dataIntro?.descrizionePrincipale?.titolo}</h1>
        </Title>

        <GoldContainer>
          <BlockTextRight
            img='event/sport.webp'
            text={documentToReactComponents(
              dataIntro?.descrizionePrincipale?.descrizione?.json
            )}
          />
          <BlockTextLeft
            img='event/clinic.webp'
            title={dataClinic?.descrizionePrincipale?.titolo || ""}
            text={documentToReactComponents(
              dataClinic?.descrizionePrincipale?.descrizione?.json
            )}
          />
          <BlockTextRight
            img='event/experience.webp'
            title={dataExpirience?.descrizionePrincipale?.titolo || ""}
            text={documentToReactComponents(
              dataExpirience?.descrizionePrincipale?.descrizione?.json
            )}
          />
        </GoldContainer>
        <GoldButton style={{ marginTop: 50 }}>RICHIEDI INFORMAZIONI</GoldButton>
      </MainContainer>
    </FlexContainer>
  );
}

function BlockTextRight(props: {
  text: React.ReactNode;
  img: string;
  title?: string;
}) {
  return (
    <Container>
      <ImgContainer right>
        <img src={props.img} />
      </ImgContainer>
      <TextContainer>
        <GoldTitle>{props.title}</GoldTitle>
        {props.text}
      </TextContainer>
    </Container>
  );
}

function BlockTextLeft(props: {
  text: React.ReactNode;
  img: string;
  title?: string;
}) {
  return (
    <Container>
      <TextContainer>
        <GoldTitle>{props.title}</GoldTitle>
        {props.text}
      </TextContainer>
      <ImgContainer>
        <img src={props.img} />
      </ImgContainer>
    </Container>
  );
}
